import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { useRouteLoaderData } from 'react-router-dom'

import type { LoaderData } from '../../../../types'
import type { agendaLoader } from '../Agenda.loader'

export default function EmptyAgenda() {
  const { t } = useTranslation('dashboard')
  const { events, onlySponsorships } = useRouteLoaderData('inscriptions') as LoaderData<
    ReturnType<typeof agendaLoader>
  >

  return (
    <Stack
      sx={theme => ({
        background: theme.colors.whiteBackground,
        width: '100%',
        height: '100%',
      })}
      direction="row"
      gap="1rem"
      alignItems="center"
      justifyContent="center"
      padding="0 10%"
      textAlign="center"
    >
      <Typography variant="h3" lineHeight={2}>
        {events?.length || onlySponsorships?.length
          ? `${t(
              "Sélectionnez un événement dans la liste de gauche pour afficher vos détails d'inscriptions et le programme de l'événement"
            )}.`
          : `${t("Vous n'êtes inscrit à aucun événement")}.`}
      </Typography>
    </Stack>
  )
}
